import React from 'react';
import {
  makeStyles, Typography
} from '@material-ui/core';
import { Add } from '@material-ui/icons';

import Button from 'src/components/Button';

import Node from './Node';
import Card from '../../../components/Card';
import { IS_FOCUSED } from './constants';


const useStyles = makeStyles((theme) => ({
  button: {
    minWidth: 0,
    padding: 4,
  },
  buildingCard: {
    border: `3px dashed ${theme.palette.text.secondary}`,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0.5
  },
  box: {
    alignItems: 'center',
    justifyContent: 'center',
  }
}));

const AddNode = ({
  data,
}: any) => {
  const classes = useStyles();

  return (
    <Node>
      {
        data.nodeStyle === IS_FOCUSED ? (
          <Card
            p={1}
            className={classes.buildingCard}
            boxProps={{
              className: classes.box,
            }}
          >
            <Typography variant="h6">BUILDING</Typography>
          </Card>
        ) : (
          <Button look="grey" className={classes.button}>
            <Add />
          </Button>
        )
      }
    </Node>
  );
};

export default AddNode;
